<template>
  <NotificationDrawer v-if="!mobile" />
  <NotificationSheet v-else />
</template>

<script lang="ts" setup>
import NotificationDrawer from '@/modules/Notification/components/NotificationDrawer/NotificationDrawer.vue'
import NotificationSheet from '@/modules/Notification/components/NotificationSheet/NotificationSheet.vue'
import { useResponsiveLayout } from '@/modules/Core/composables'

defineOptions({
  name: 'NotificationHost',
})

const { mobile } = useResponsiveLayout()
</script>
